<a (click)="closeDialog()"
    class="dn-button"
    [ngClass]="{'hoved': hover}"
    [ngStyle]="getStyle()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">{{ buttonText }}</a>
